import { LOKASI_ABSEN } from "../constants";

export const getLokasi = (datang, pulang) =>
  (pulang?.id_lokasi && LOKASI_ABSEN[pulang?.id_lokasi]) ||
  (datang?.id_lokasi && LOKASI_ABSEN[datang?.id_lokasi]);
